import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Globals } from 'src/app/globals';
import { ApiService } from 'src/app/services/api.service';
import { SessionService } from 'src/app/services/session.service';
import { PopoverComponent } from '../popover/popover.component';

@Component({
  selector: 'app-reusable-header',
  templateUrl: './reusable-header.component.html',
  styleUrls: ['./reusable-header.component.scss'],
})
export class ReusableHeaderComponent implements OnInit {
  firstName: string;
  customerNumber: string;
  companyName: string;

  isUserAdmin: boolean = false;
  isBusinessVersion: boolean;
  stylingVersion: string;

  b2bUsername: string;

  constructor(private api: ApiService, public popover: PopoverController, private session: SessionService, private globals: Globals) { }

  async ngOnInit() {
    this.isBusinessVersion = this.session.isScoped(this.globals.BUSINESS_SCOPE) 
    this.stylingVersion = this.isBusinessVersion ? '-biz' : '';

    !this.isBusinessVersion && this.api.getCurrentUser().subscribe(
      (res: any) => {
        this.firstName = res.firstName;
        this.customerNumber = res.customerNumber;
        this.companyName = res.companyName;
      }
    );
  
    if (this.isBusinessVersion) {
      this.b2bUsername = this.session.userId;
    }

    this.session.retrieveFromStorage().then(() => {
      this.isUserAdmin = this.session.isScoped("admin");
    })
  }
  async openPopover(ev) {
    const popover = await this.popover.create({
      component: PopoverComponent,
      event: ev,
      cssClass: 'customPopover',
      translucent: true
    });
    return await popover.present();
  }
}
